import { Component, Input, OnInit, ViewChild, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'confirm-popover',
    templateUrl: './confirm-popover.component.html',
    styleUrls: ['./confirm-popover.component.scss']
})
export class ConfirmPopoverComponent implements OnInit {
    @Input() type: string = 'button';
    @Input() buttonType: string = 'string';
    @Input() tooltip: string = '';
    @Input() icon: string = 'done';
    @Input() color: string = 'primary';
    @Input() buttonTxt: string = 'Confirm';
    @Input() popoverMsg: string = '';
    @Input() popoverConfirmText: string = 'Confirm';
    @Input() popoverConfirmColor: string = 'primary';
    @Input() popoverCancelText: string = 'Cancel';
    @Input() popoverCancelColor: string = 'accent';
    @Input() disabled: boolean = false;
    @Input() class: string = '';

    @Output() onConfirm: EventEmitter<any> = new EventEmitter();
    @Output() onCancel: EventEmitter<any> = new EventEmitter();

    @Input() isLoading: boolean;
    @Output() isLoadingChange: EventEmitter<any> = new EventEmitter();

    @ViewChild('confirmElement') confirmElement!: MatButton;

    dataBsPopover: string = 'focus';

    @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

    constructor() {}

    ngOnInit(): void {}

    confirm() {
        this.onConfirm.emit();
        this.menuTrigger.closeMenu();
    }

    openMenu() {
        //console.log("called confirm-popover's openMenu()")
        //console.log(this.buttonType);
        //this.menuTrigger.openMenu();
        this.confirmElement.focus();
    }

    closeMenu() {
        this.onCancel.emit();
        this.menuTrigger.closeMenu();
    }

    openPopover() {
        this.menuTrigger.openMenu();
        this.openMenu();
    }
}
